/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown>, words: NonNullable<unknown> }} Wrapped_Card_LabelInputs */

const en_us2_wrapped_card_label = /** @type {(inputs: Wrapped_Card_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.words}`)
};

const pt_br2_wrapped_card_label = /** @type {(inputs: Wrapped_Card_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.words}`)
};

const es_419_wrapped_card_label = /** @type {(inputs: Wrapped_Card_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.words}`)
};

const pt_pt2_wrapped_card_label = /** @type {(inputs: Wrapped_Card_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.words}`)
};

const fr_fr2_wrapped_card_label = /** @type {(inputs: Wrapped_Card_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.words}`)
};

const de_de2_wrapped_card_label = /** @type {(inputs: Wrapped_Card_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.words}`)
};

const it_it2_wrapped_card_label = /** @type {(inputs: Wrapped_Card_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.words}`)
};

/**
* | output |
* | --- |
* | "{value} {words}" |
*
* @param {Wrapped_Card_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_card_label = /** @type {((inputs: Wrapped_Card_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Card_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_card_label(inputs)
	if (locale === "es-419") return es_419_wrapped_card_label(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_card_label(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_card_label(inputs)
	if (locale === "de-DE") return de_de2_wrapped_card_label(inputs)
	if (locale === "it-IT") return it_it2_wrapped_card_label(inputs)
	return en_us2_wrapped_card_label(inputs)
});
export { wrapped_card_label as "wrapped.card_label" }